export default async function Verify2FAApi(userId, code) {
  let res = "";
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({ userId, code }),
    };

    await fetch(
      `${process.env.REACT_APP_API_URL}v1/auth/verify-2fa`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error verifying 2FA: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
